import * as xlsx from "xlsx";
import * as initalObject from '../constants/MassUploadValues';

export function OperationHourFile(target, brand, callback, emptyCallback) {
    const makeArray: any = [];
    const makeDeliveryDaysArray: any = [];
    let isOnlyDeliveryAvailable = true;
    if (target.files) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const langTranslations = {};
            const data = e.target && e.target.result;
            const uploadWorkbook = xlsx.read(data, { type: "array" });
            const TimeSheet = uploadWorkbook.SheetNames[1];
            const workTimeSheet = uploadWorkbook.Sheets[TimeSheet];
            const MUSheet = uploadWorkbook.SheetNames[0];
            const worksheetMU = uploadWorkbook.Sheets[MUSheet];
            xlsx.utils.sheet_to_json(workTimeSheet, {
                raw: false,
                header: ['time', 'key', 'value']

            }).forEach((item: any) => {
                if (item['key'] || item['value'])
                    langTranslations[item['key']] = item['value'] || item['key']
            });
            const getCurrentBrandInfo = initalObject.fileBrandLists[worksheetMU?.A1?.w]
            if (!getCurrentBrandInfo) {
                emptyCallback('operationHours.massUpload.inValidBrand')
                return;
            } else if (getCurrentBrandInfo.brand !== brand) {
                emptyCallback('operationHours.massUpload.correctBrand')
                return;
            }
            const getHeader = [...initalObject[getCurrentBrandInfo.brand + getCurrentBrandInfo.setting + 'Header']];
            if (getCurrentBrandInfo.brand === 'BK' && getCurrentBrandInfo.setting === 'Base') {
                getHeader.splice(24, 0, "dhIsOpenedClosed");
            }
            const json = xlsx.utils.sheet_to_json(worksheetMU, {
                raw: false,
                header: getHeader,

            }).slice(3);
            if (!json.length) {
                emptyCallback('operationHours.massUpload.emptyFile')
                return;
            } else {
                json.forEach((eachRowJson: any) => {
                    const translations = {
                        data: {
                            "isCalculated": "N",
                        },
                        restaurants: []
                    };
                    translations.restaurants = eachRowJson?.restaurants?.split(',').map(element => element.trim()).filter(element => element) || [];
                    delete eachRowJson?.restaurants;
                    translations.data = { ...translations.data, ...initalObject.getkeyValuePair(eachRowJson, getCurrentBrandInfo.setting, getCurrentBrandInfo.brand, langTranslations) }
                    isOnlyDeliveryAvailable = isOnlyDeliveryAvailable ? translations.data['isOnlyDeliveryDays'] : isOnlyDeliveryAvailable;
                    delete translations.data['isOnlyDeliveryDays'];
                    if (getCurrentBrandInfo.setting === 'Base') {
                        translations.data['setting'] = 'base';
                        if (translations.data['selectedDeliveryDays']) {
                            const deliveryDaysToLeave = initalObject['initialDeliveryDays'].filter(x => !translations.data['selectedDeliveryDays'].includes(x)).map(days => days.split("_")[1]);
                            const deliveryDaysJSONData = {
                                data: {
                                    deliveryDays: translations.data['deliveryDays'] ? translations.data['deliveryDays'] : [],
                                    deliveryDaysToLeave: deliveryDaysToLeave
                                },
                                restaurants: translations.restaurants || []
                            }
                            makeDeliveryDaysArray.push(deliveryDaysJSONData)
                            delete translations.data['deliveryDays']
                            delete translations.data['selectedDeliveryDays']
                        }
                    }
                    makeArray.push(translations)
                });
                if (makeArray.length) {
                    const JSONData = {
                        setting: getCurrentBrandInfo.setting,
                        "massUploadThroughXML": true,
                    }
                    if (getCurrentBrandInfo.setting === 'Base') {
                        JSONData['deliveryDays'] = {
                            rows: makeDeliveryDaysArray,
                            "massUploadThroughXML": true,
                        }
                        if (isOnlyDeliveryAvailable && !makeDeliveryDaysArray.length) {
                            emptyCallback('operationHours.massUpload.fail')
                            return;
                        } else if (isOnlyDeliveryAvailable) {
                            JSONData['isOnlyDeliveryAvailable'] = isOnlyDeliveryAvailable
                            callback(JSONData, target)
                            return;
                        }
                    }
                    JSONData['rows'] = makeArray;
                    JSONData['file'] = {
                        contentType: target.files[0].type,
                        name: target.files[0].name
                    }
                    callback(JSONData, target)
                } else {
                    emptyCallback('operationHours.massUpload.fail')
                }
            }
        };
        reader.readAsArrayBuffer(target.files[0]);
    }

}
